
import '../index.js';
import 'jquery';
import '../utils/slick.js';
import '../modules/block-brands-optimized.js';
import '../modules/block-business.js';
import '../modules/block-tabs-optimized.js';
import '../modules/block-integration-optimized.js';
import '../modules/block-reviews-optimized.js';
import '../modules/hv2-faqs.js';
import { screenshotsAccordion } from '../utils/screenshots';

// const addHomeVideoAttribute = () => {
//   const homeVideo = document.querySelector('#home-hero video source');

//   if (homeVideo) {
//     //  if (isMobile) {
//     //      homeVideo.setAttribute('data-src', '/assets/home-hero-mobile.mp4');
//     //} else {
//     homeVideo.setAttribute('data-src', '/assets/home-hero-desktop-vw.mp4');
//     //}
//   };
// }

document.addEventListener('DOMContentLoaded', function (e) {
  screenshotsAccordion();
});
